"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const index_view_1 = __importDefault(require("./index.view"));
const sites_1 = require("@/store/ducks/sites");
const react_redux_1 = require("react-redux");
function SiteListTitle() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const onAddSite = () => {
        dispatch((0, sites_1.openAddSiteModal)());
        return;
    };
    return react_1.default.createElement(index_view_1.default, { onAddSite: onAddSite });
}
exports.default = SiteListTitle;
